<template>
    <FKBreadCrumb :page="$t('page.invite_user')" :title="$t('page.invite_user')">
  </FKBreadCrumb>
    <InviteUserForm />
    <InvitationList/>
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
  import InviteUserForm from "@/components/FK/UserForm/InviteUserForm.vue";
import InvitationList from "@/components/FK/UserForm/InvitationList.vue";
  
  export default defineComponent({
    name: "InviteUserPage",
    components: {
      FKBreadCrumb,
      InviteUserForm,
      InvitationList
    },
    computed: {
      page_title(): string { return this.$route.query.role_name === undefined ? this.$t('page.create_user') : `${this.$t('cta.create')} ${this.$route.query.role_name}`}
    }
  });
  </script>